import React from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';
import { uniqBy } from 'lodash';
import loadData from '../lib/bootstrapped_data';
import ProductMap from './here_maps/ProductMap';

const UPDATE_INTERVAL = 5000;

export default class LiveProductMapContainer extends React.Component {
  constructor(props) {
    super(props);

    this.isMountedFlag = false;
    this.liveDataTimeoutId = null;
    this.liveDataRequest = null;

    const drtArea = loadData('drt_area') !== undefined ? loadData('drt_area').data : undefined;
    const intermodalArea = loadData('intermodal_area') !== undefined ? loadData('intermodal_area').data : undefined;
    const calculatedRoute = loadData('calculated_route');
    const stations = loadData('stations');
    const places = loadData('places');
    const vehiclePositions = loadData('positions');
    const boundingBox = loadData('bbox');

    this.state = {
      drtArea,
      intermodalArea,
      calculatedRoute,
      boundingBox,
      stations: stations.data,
      places: places.data,
      trail: vehiclePositions && vehiclePositions.data,
      rides: [],
      vehicles: [],
      vehicleCurrentPositions: [],
      vehicleLastPositions: []
    };
  }

  componentDidMount() {
    this.isMountedFlag = true;
    this.loadLiveData();
  }

  componentWillUnmount() {
    this.isMountedFlag = false;

    if (this.liveDataTimeoutId) {
      window.clearTimeout(this.liveDataTimeoutId);
      this.liveDataTimeoutId = null;
    }

    if (this.liveDataRequest?.abort) {
      this.liveDataRequest.abort();
      this.liveDataRequest = null;
    }
  }

  handleLiveDataUpdate(response) {
    if (!this.isMountedFlag) {
      return;
    }

    const newState = {
      rides: response.data.rides,
      vehicles: response.data.vehicles,
      vehicleCurrentPositions: response.data.vehicle_current_positions,
      vehicleLastPositions: response.data.vehicle_last_positions
    };

    if (this.state.trail) {
      newState.trail = uniqBy([...this.state.trail, ...response.data.vehicle_current_positions], 'id');
    }

    this.setState(newState);

    this.scheduleNextLoad();
  }

  scheduleNextLoad() {
    this.liveDataTimeoutId = window.setTimeout(() => this.loadLiveData(), UPDATE_INTERVAL);
  }

  loadLiveData() {
    if (!this.isMountedFlag) {
      return;
    }

    if (this.props.isVisible) {
      // Keep a reference to the jqXHR itself (not the derived promise returned
      // by .then/.catch, which in jQuery 3 does not carry .abort()) so that
      // componentWillUnmount can actually cancel the in-flight request.
      const request = $.getJSON(this.props.liveDataUrl);
      this.liveDataRequest = request;

      request
        .then((response) => {
          this.liveDataRequest = null;
          this.handleLiveDataUpdate(response);
        })
        .catch((error) => {
          this.liveDataRequest = null;

          if (error?.statusText === 'abort' || !this.isMountedFlag) {
            return;
          }

          console.error('There was an error loading the live map data:');
          console.error(error);

          this.scheduleNextLoad();
        });

      return;
    }

    this.scheduleNextLoad();
  }

  render() {
    return (
      <ProductMap
        drtArea={this.state.drtArea}
        intermodalArea={this.state.intermodalArea}
        boundingBox={this.state.boundingBox}
        calculatedRoute={this.state.calculatedRoute}
        stations={this.state.stations}
        places={this.state.places}
        rides={this.state.rides}
        vehicles={this.state.vehicles}
        vehicleCurrentPositions={this.state.vehicleCurrentPositions}
        trail={this.state.trail}
        vehicleLastPositions={this.state.vehicleLastPositions}
      />
    );
  }
}

LiveProductMapContainer.defaultProps = {};

LiveProductMapContainer.propTypes = {
  liveDataUrl: PropTypes.string.isRequired,
  isVisible: PropTypes.bool.isRequired
};
